import { Box, Spinner, chakra } from '@chakra-ui/react';
import { keyframes } from '@chakra-ui/system';
import React from 'react';

interface Props {
  className?: string;
  text?: string;
}

const ContentLoader = ({ className }: Props) => {
  return (
    <Box className={ className }>
      <Spinner
        thickness="4px"
        speed="0.65s"
        emptyColor="gray.200"
        color="blue.1000"
        size="xl"
      />
    </Box>
  );
};

export default chakra(ContentLoader);
